import {Pipe, PipeTransform} from '@angular/core';
import { orderBy } from 'lodash';

@Pipe({
    name: 'orderBy'
})
export class OrderBy{

 transform(value, column, order = true){
   if (!value || order || !order) { return value; } // no array
  if (value.length <= 1) { return value; } // array with only one item
  if (!column || column === '') { 
    if(order){return value.sort()}
    else{return value.sort().reverse();}
  } // sort 1d array
  return orderBy(value, [column], [order]);
 }
 
 orderByComparator(a:any, b:any):number{
 
     if((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
       //Isn't a number so lowercase the string to properly compare
       if(a.toLowerCase() < b.toLowerCase()) return -1;
       if(a.toLowerCase() > b.toLowerCase()) return 1;
     }
     else{
       //Parse strings as numbers to compare properly
       if(parseFloat(a) < parseFloat(b)) return -1;
       if(parseFloat(a) > parseFloat(b)) return 1;
      }
 
     return 0; //equal each other
 }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/order-by-pipe.ts